<template>
  <div class="app-events-advanced-search">
    <v-row justify="center" align="center">
      <v-col v-if="IS_ADMIN">
        <v-text-field
          @change="updateFilter('createdByEmail', $event)"
          :value="filters.createdByEmail"
          append-icon="mdi-account-plus"
          hide-details="true"
          label="Creator"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('brand', $event)"
          :items="brandItems"
          :value="filters.brand"
          label="Brand"
          item-value=""
          append-icon="$Caret"
          hide-details="true"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('eventType', $event)"
          :items="eventTypeItems"
          :value="filters.eventType"
          label="Event Segment"
          append-icon="$Caret"
          hide-details="true"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('language', $event)"
          :items="languageItems"
          :value="filters.language"
          label="Language"
          append-icon="$Caret"
          hide-details="true"
        />
      </v-col>
      <v-col>
        <v-checkbox
          @change="updateFilter('archived', $event ? null : '0')"
          :input-value="filters.archived !== '0'"
          :on-icon="'$TMobileFullCheckbox'"
          off-icon="$TMobileEmptyCheckbox"
          hide-details="true"
        >
          <span
            slot="label"
            class="black--text"
          >
            Display Archived Events
          </span>
        </v-checkbox>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-menu
          v-model="startingBeforeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="filters.startingBeforeDate"
              label="Starting Before"
              append-icon="$Calendar"
              readonly
              v-bind="attrs"
              class="app-events-advanced-search__calendarpicker"
              v-on="on"
            />
          </template>
          <v-date-picker
            @change="updateFilter('startingBeforeDate', $event)"
            @click:date="beforeDateAction"
            @input="startingBeforeMenu = false"
            :landscape="true"
            :show-current="false"
            :value="filters.startingBeforeDate"
            no-title
          />
        </v-menu>
      </v-col>
      <v-col>
        <v-menu
          v-model="startingAfterMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="filters.startingAfterDate"
              label="Starting After"
              append-icon="$Calendar"
              readonly
              v-bind="attrs"
              class="app-events-advanced-search__calendarpicker"
              v-on="on"
            />
          </template>
          <v-date-picker
            @change="updateFilter('startingAfterDate', $event)"
            @click:date="afterDateAction"
            @input="startingAfterMenu = false"
            :landscape="true"
            :show-current="false"
            :value="filters.startingAfterDate"
            no-title
          />
        </v-menu>
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('organization', $event)"
          :items="tmusItems"
          :value="filters.organization"
          label="Organization"
          append-icon="$Caret"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('region', $event)"
          :items="regionItems"
          :value="filters.region"
          label="Region"
          append-icon="$Caret"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('state', $event)"
          :items="stateItems"
          :value="filters.state"
          label="State"
          append-icon="$Caret"
        />
      </v-col>
      <v-col>
        <v-select
          @change="updateFilter('dma', $event)"
          :items="dmaItems"
          :value="filters.dma"
          label="DMA"
          append-icon="$Caret"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import OptionData from '../../utility/OptionData.js';

export default {
  name: 'AdvancedSearchForm',
  props: {
    filterContext: {
      type: String,
      default: 'allEvents'
    }
  },
  data() {
    return {
      userFilter: '',
      brandItems: ['T-Mobile', 'Metro'],
      eventTypeItems: OptionData.SegmentAudienceItems(),
      languageItems: [
        { value: 'en', text: 'English' },
        { value: 'bi', text: 'English and Spanish' }
      ],
      sortItems: [],
      startingAfterDateZ: '',
      startingBeforeDataZ: '',
      tmusItems: OptionData.Organizations(),
      regionItems: OptionData.Regions(),
      stateItems: OptionData.States(),
      dmaItems: OptionData.DMAs(),
      modal: false,
      startingAfterMenu: false,
      startingBeforeMenu: false,
      localCreatedByEmail: null
    };
  },
  methods: {
    ...mapActions('EVENT_TABLE_STORE', ['APPLY_FILTER']),
    ...mapActions('EVENT_MANAGER_STORE', ['SET_FILTER']),
    beforeDateAction(data) {
      this.SET_FILTER({
        label: 'Starting Before Date',
        value: data + ' 00:00:00',
        name: 'startingBeforeDate'
      });
    },
    afterDateAction(data) {
      this.SET_FILTER({
        label: 'Starting After Date',
        value: data + ' 00:00:00',
        name: 'startingAfterDate'
      });
    },
    applyEmailFilter() {
      this.APPLY_FILTER({
        filter_key: 'createdByEmail',
        filter_value: this.localCreatedByEmail
      });
    },
    updateFilter(key, value) {
      this.$store.dispatch('EVENT_TABLE_STORE/APPLY_FILTER', {
        filter_key: `${this.filterContext}.${key}`,
        filter_value: value
      });
    }
  },
  computed: {
    ...mapGetters({
      IS_ADMIN: `account/IS_ADMIN`,
      FILTER_INPUTS: `FILTER_INPUTS`
    }),
    ...mapState('EVENT_TABLE_STORE', {
      filters(state) {
        return state.FILTERS[this.filterContext];
      },
    }),
  }
};
</script>

<style lang="scss">
.app-events-advanced-search .v-icon.v-icon {
  color: var(--v-secondary-base);
}
.app-events-advanced-search {
  display: none;
  transition: opacity 1s ease-out;
  opacity: 0;
}
.app-events-advanced-search .v-input__slot {
  margin-bottom: 0;
}
.app-events-advanced-search.active {
  opacity: 1;
  display: block;
}

@media only screen and (max-width: 767px) {
  .app-events-advanced-search .row {
    flex-direction: column;
  }
}
</style>
